import React, { PureComponent } from 'react';

import { UserComponent } from 'react/UserComponent.jsx';

class MyTeamNameComponent extends PureComponent {
	render() {
		const { match } = this.props;

		if(match.isSingles()) {
			return <UserComponent user={myUser} />;
		}
		else if(match.isDoubles()) {
			return 'Your Team';
		}
	}
}

export { MyTeamNameComponent };